import { FC } from 'react'
import { ImageProps } from 'next/image'

import type { ScoreStarProps } from '../ScoreStar'
import { ActionButtonProps } from '../ActionButton'
import { LinkProps } from '../Link'
import { sizes } from '../../theme'

import * as SC from './styled'

export type ProductBannerProps = {
  className?: string
  offerLink?: LinkProps
  description: string
  score?: ScoreStarProps
  priceWithoutReduction?: string
  priceWithReduction?: string
  priceWithReductionPrefix?: string
  priceLabelLeft?: string
  priceDiscountLeft?: string
  image?: ImageProps
  webSiteLinkButton?: ActionButtonProps
  accountCreationLinkButton?: ActionButtonProps
  stockTextInfo?: string
  stockButton?: ActionButtonProps
}

const ProductBanner: FC<ProductBannerProps> = (props) => {
  const {
    className,
    offerLink,
    description,
    score,
    priceWithoutReduction,
    priceWithReduction,
    priceWithReductionPrefix,
    priceLabelLeft,
    priceDiscountLeft,
    image,
    webSiteLinkButton,
    accountCreationLinkButton,
    stockTextInfo,
    stockButton,
  } = props

  return (
    <SC.ContainerSlide className={className}>
      <SC.BlockImage>
        <SC.OfferLink {...offerLink}>
          {image && (
            <SC.SImage
              {...image}
              width={365}
              height={365}
              priority={true}
              sizes={`(min-width: ${sizes.tablet}px) 50vw, 70vw`}
            />
          )}
        </SC.OfferLink>
      </SC.BlockImage>
      <SC.BlockContent $priceWithReduction={priceWithReduction}>
        <SC.BlockTitleDescription>
          <SC.Title>
            <SC.OfferLink {...offerLink} />
          </SC.Title>
          <SC.Description>{description}</SC.Description>
        </SC.BlockTitleDescription>
        {(score || priceWithoutReduction || priceWithReduction) && (
          <SC.PriceScoreBlock>
            {score && <SC.Score {...score} />}
            <SC.PriceBlock>
              <SC.PriceLeft>
                {priceWithoutReduction && (
                  <SC.PriceWithoutReduction>
                    <s>{priceWithoutReduction}</s>
                  </SC.PriceWithoutReduction>
                )}
                {priceDiscountLeft && (
                  <SC.PriceDiscountLeft>
                    {priceDiscountLeft}
                  </SC.PriceDiscountLeft>
                )}
                {priceLabelLeft && (
                  <SC.PriceLabelLeft>{priceLabelLeft}</SC.PriceLabelLeft>
                )}
              </SC.PriceLeft>
              <SC.PriceRight>
                {priceWithReduction && (
                  <SC.PriceWithReduction data-prefix={priceWithReductionPrefix}>
                    {priceWithReduction}
                  </SC.PriceWithReduction>
                )}
              </SC.PriceRight>
            </SC.PriceBlock>
          </SC.PriceScoreBlock>
        )}
        {(webSiteLinkButton ||
          accountCreationLinkButton ||
          stockButton ||
          stockTextInfo) && (
          <SC.ButtonBlock>
            {webSiteLinkButton && (
              <SC.LinkButton
                {...webSiteLinkButton}
                className={'btn_link_offer'}
              />
            )}
            {accountCreationLinkButton && (
              <SC.LinkButton
                {...accountCreationLinkButton}
                className={'btn_link_offer'}
              />
            )}
            <SC.StockBlock>
              {stockTextInfo && (
                <SC.StockTextInfo>{stockTextInfo}</SC.StockTextInfo>
              )}
              {stockButton && <SC.StockButton {...stockButton} />}
            </SC.StockBlock>
          </SC.ButtonBlock>
        )}
      </SC.BlockContent>
    </SC.ContainerSlide>
  )
}

export default ProductBanner
